import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Trophy } from "lucide-react";

function Stat({ label, value, testid }) {
  return (
    <div className="rounded-lg bg-[#070707] border border-[#14110a] py-2">
      <div className="text-[10px] uppercase tracking-wide text-slate-500">{label}</div>
      <div data-testid={testid} className="font-heading text-lg font-black text-slate-100">{value}</div>
    </div>
  );
}

export function PlayerSeasonRacePanel({ wsbfId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/player/${wsbfId}/season`)
      .then(({ data }) => setData(data))
      .catch(() => setErr(true));
  }, [wsbfId]);

  if (err || !data || !data.season) return null;
  const s = data.summary || {};
  const results = data.results || [];

  return (
    <div data-testid="season-race-panel" className="rounded-xl border border-[#2b2512] bg-[#0a0a0a] p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-heading text-lg font-black uppercase tracking-wide text-[#E5B842] flex items-center gap-2">
          <Trophy className="w-4 h-4" /> Season Race
        </h3>
        <span className="text-xs font-mono text-slate-400">{data.season.name}</span>
      </div>
      <div className="grid grid-cols-4 gap-2 mb-3 text-center">
        <Stat label="Position" value={s.position ? `#${s.position}` : "—"} testid="season-position" />
        <Stat label="Total" value={s.season_total_points ?? 0} testid="season-total" />
        <Stat label="Carry-over" value={s.carry_over_points ?? 0} testid="season-carry" />
        <Stat label="Best-8" value={s.earned_best8_points ?? 0} testid="season-earned" />
      </div>
      <div className="text-xs uppercase tracking-wide text-slate-500 mb-1">Results ({results.length})</div>
      <div className="space-y-1" data-testid="season-results-list">
        {results.length === 0 && <div className="text-sm text-slate-500">No season results yet.</div>}
        {results.map((r) => (
          <div key={r.id} data-testid={`season-result-${r.id}`}
            className={`flex items-center justify-between rounded-lg px-3 py-2 text-sm border ${r.counts_in_best8 ? "border-[#E5B842]/40 bg-[#E5B842]/5" : "border-[#14110a] bg-[#070707]"}`}>
            <div className="min-w-0">
              <div className="font-mono text-slate-200 truncate">{r.tournament_id} · {r.tier_code}</div>
              <div className="text-xs text-slate-500">{r.placement_label || "—"} · {r.result_date ? new Date(r.result_date).toLocaleDateString() : ""}</div>
            </div>
            <div className="text-right shrink-0 ml-3">
              <div className="font-bold text-slate-100">{r.points_awarded} pts</div>
              <div className={`text-[10px] font-bold uppercase ${r.result_status !== "ACTIVE" ? "text-red-400" : r.counts_in_best8 ? "text-[#E5B842]" : "text-slate-500"}`}>
                {r.result_status !== "ACTIVE" ? r.result_status : r.counts_in_best8 ? `Counts #${r.best8_rank}` : "Not counting"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
